import { Component, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { CarouselModule } from 'primeng/carousel';
import { AgendaService } from '../../services/agenda/agenda.service';

interface Evento {
  dscHoraInicioEvento: string;
  nomePublicacao: string;
  dscEnderecoEvento: string;
  binPublicacao: string;
}

@Component({
  selector: 'app-agenda',
  standalone: true,
  imports: [RouterModule, CommonModule, CarouselModule],
  templateUrl: './agenda.component.html',
  styleUrls: ['./agenda.component.scss']
})
export class AgendaComponent implements OnInit {

  iconCard = [
    { name: 'Hoje', icon: '/assets/svg/calendario.svg' },
    { name: 'Amanhã', icon: '/assets/svg/calendario.svg' },
    { name: 'Fim de semana', icon: '/assets/svg/calendario.svg' },
    { name: 'Mês', icon: '/assets/svg/calendario.svg' },
  ];

  paginatedItems: Evento[] = [];
  showCarousel: boolean = false;
  selectedFilter: any = null;
  
  responsiveOptions = [
    { breakpoint: '1024px', numVisible: 3, numScroll: 3 },
    { breakpoint: '768px', numVisible: 2, numScroll: 2 },
    { breakpoint: '560px', numVisible: 1, numScroll: 1 }
  ];

  constructor(private router: Router, private agendaService: AgendaService) {}

  ngOnInit(): void {}

  selecionarPeriodo(item: any): void {
    if (this.selectedFilter && this.selectedFilter.name === item.name && this.showCarousel) {
      this.showCarousel = false;
      this.selectedFilter = null;
      this.paginatedItems = [];
      return;
    }
    
    this.selectedFilter = item;
    this.showCarousel = true;
    let datInicial: string = '';
    let datFinal: string = '';
    const hoje = new Date();

    if (item.name === 'Hoje') {
      datInicial = this.formatDateForApi(hoje);
      datFinal = this.formatDateForApi(hoje);
    } else if (item.name === 'Amanhã') {
      const amanha = new Date(hoje);
      amanha.setDate(hoje.getDate() + 1);
      datInicial = this.formatDateForApi(amanha);
      datFinal = this.formatDateForApi(amanha);
    } else if (item.name === 'Fim de semana') {
      const day = hoje.getDay();
      const saturday = new Date(hoje);
      const daysUntilSaturday = (6 - day + 7) % 7 || 6;
      saturday.setDate(hoje.getDate() + daysUntilSaturday);
      const sunday = new Date(saturday);
      sunday.setDate(saturday.getDate() + 1);
      datInicial = this.formatDateForApi(saturday);
      datFinal = this.formatDateForApi(sunday);
    } else if (item.name === 'Mês') {
      const firstDay = new Date(hoje.getFullYear(), hoje.getMonth(), 1);
      const lastDay = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0);
      datInicial = this.formatDateForApi(firstDay);
      datFinal = this.formatDateForApi(lastDay);
    }

    this.agendaService.getEventos(datInicial, datFinal).subscribe(
      (res) => {
        if (res.formatoArquivos && res.formatoArquivos.length > 0) {
          this.paginatedItems = res.formatoArquivos.map((evento: any) => ({
            dscHoraInicioEvento: evento.dscHoraInicioEvento,
            nomePublicacao: evento.nomePublicacao,
            dscEnderecoEvento: evento.dscEnderecoEvento,
            binPublicacao: evento.binPublicacao
          }));
        } else {
          this.paginatedItems = [];
        }
      },
      (error) => {
        console.error('Erro ao buscar eventos:', error);
        this.paginatedItems = [];
      }
    );
  }

  formatDateForApi(date: Date): string {
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);
    return `${year}-${month}-${day}`;
  }
}
